// extracted by mini-css-extract-plugin
export var boxItems = "_6i-1";
export var boxItemsLg = "_6i-2";
export var button = "_6i-7";
export var buttonHoverless = "_6i-9";
export var buttonLg = "_6i-8";
export var filterGroupBox = "_6i-0";
export var icon = "_6i-3";
export var iconSecondary = "_6i-6";
export var iconWrapper = "_6i-4";
export var iconWrapperLg = "_6i-5";
export var truncatedLabel = "_6i-a";